import { Box, Divider, Stack, Typography } from '@mui/material';

import { TopicsGlobalScoreData } from '@/domain/impact-calculate/entities/calculate.entity';
import { ScoreTag } from '@/ui/components/score/ScoreTag';
import { translate } from '@/ui/i18n';
import { getColorForScore, ScoreColor } from '@/ui/utils/get-color-for-score';

export function CardScores({
  topicsGlobalScoreData,
}: {
  topicsGlobalScoreData: TopicsGlobalScoreData;
}) {
  const { co2, env, ess } = topicsGlobalScoreData;
  const data = {
    co2: {
      value: co2.score || '-',
      colors: getColorForScore(co2.scoreLetter),
    },
    env: {
      value: env.scoreLetter || '-',
      colors: getColorForScore(env.scoreLetter),
    },
    ess: {
      value: ess.scoreLetter || '-',
      colors: getColorForScore(ess.scoreLetter),
    },
  };

  return (
    <Stack
      display={'flex'}
      direction={'row'}
      spacing={2}
      divider={<Divider orientation="vertical" flexItem />}
      flexWrap={'wrap'}
      useFlexGap
    >
      <ScoreCo2 value={data.co2.value} colors={data.co2.colors} />
      <ScoreEnv value={data.env.value} colors={data.env.colors} />
      <ScoreESS value={data.ess.value} colors={data.ess.colors} />
    </Stack>
  );
}

function ScoreCo2({
  value,
  colors,
}: {
  value: number | string;
  colors: ScoreColor;
}) {
  return (
    <Box>
      <ScoreTag value={value} colors={colors} topic="co2" />
      <Typography
        color="text.secondary"
        sx={{
          mt: 1.5,
          mb: 0.5,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {translate('Projects.teCO2')}
      </Typography>
    </Box>
  );
}

function ScoreEnv({ value, colors }: { value: string; colors: ScoreColor }) {
  return (
    <Box>
      <ScoreTag value={value} colors={colors} topic="env" />
      <Typography
        color="text.secondary"
        sx={{
          mt: 1.5,
          mb: 0.5,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {translate('Projects.env-short')}
      </Typography>
    </Box>
  );
}

function ScoreESS({ value, colors }: { value: string; colors: ScoreColor }) {
  return (
    <Box>
      <ScoreTag value={value} colors={colors} topic="ess" />
      <Typography
        color="text.secondary"
        sx={{
          mt: 1.5,
          mb: 0.5,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {translate('Projects.ess-short')}
      </Typography>
    </Box>
  );
}
